import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FieldConfig } from '../../models/field.interface';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PdfImagePreviewComponent } from '../../pdf-image-preview/pdf-image-preview.component';
@Component({
selector: 'app-pdf-field',
template: `
<div [formGroup]="group" *ngIf="field.style.visibility" class="urlField">
  <div class="hazard-description">
    <a (click)="pdfPreview()">{{field.name}}</a>
  </div>
</div>
`,
styles: [`.hazard-description{margin: 10px 0}.modal-dialog{height:70vh}.modal-content{margin-top : 5%}.modal-footer{margin:0;padding:10px}`]
})
export class PdfFieldComponent implements OnInit {
field: FieldConfig;
group: FormGroup;
constructor(
  private modalService: NgbModal
) {}
ngOnInit() {  
}
pdfPreview(){
  let modalOptions: any = {
    size: 'md',
    centered: true,
    windowClass: 'md-dialog-large',
  };
  const modalRef = this.modalService.open(
    PdfImagePreviewComponent,
    modalOptions
  );
  modalRef.componentInstance.pdfPreview = this.field.data;
  modalRef.componentInstance.fieldType = this.field.type;
}
}


// WEBPACK FOOTER //
// ./src/app/rFF/fields/pdf-field/pdf-field.component.ts